export const PERMISSION_NONE =              0x00
export const PERMISSION_READ =              0x01
export const PERMISSION_WRITE =             0x02
export const PERMISSION_DELETE =            0x03
export const PERMISSION_CREATOR =           0x04

export const SHOW_LOADER =                  0x01
export const FETCH_CALENDARS =              0x02
export const FETCH_EVENT =                  0x03
export const FETCH_CALENDAR =               0x04
export const FETCH_USER =                   0x05
export const LOGIN =                        0x06
export const FETCH_ME =                     0x07
export const REGISTER =                     0x08
